import { usePollingInterval } from 'src/hooks/usePollingInterval'
import { useUnreadMessagesQuery } from '@paintscout/api'
import type { SidebarButtonProps } from '@paintscout/ui'
import { SidebarButton } from '@paintscout/ui'
import React from 'react'
import { useQuote } from '@paintscout/react-quote'

export default function QuoteSidebarButton(props: SidebarButtonProps) {
  const { quote } = useQuote()
  const unreadMessagesQuery = useUnreadMessagesQuery({
    pollInterval: usePollingInterval(50000),
    variables: {
      quoteId: quote._id
    }
  })

  return <SidebarButton {...props} badgeCount={unreadMessagesQuery.data?.unreadMessages?.length} />
}
